module.exports = require('./lib/autoBind');



//////////////////
// WEBPACK FOOTER
// ./~/react-autobind/index.js
// module id = 1984
// module chunks = 0 1 3